const guardianMessages = [
    {
        guardianName: 'Cyborg Bear',
        page: 'StartIdentifyScam',
        messages: [
            "Welcome to the Scam identification centre. This is where you identify possible scam scenarios.",
            `You can use "elemental fingerprinting" to identify possible scams here.`,
            `Over here, we use logic and the power of AI to help you identify possible scams`,
            `Scam protect's elemental fingerprinting for scam identification is powered by "The Wisdom Approach"`,
        ]
    },
    {
        guardianName: 'Cyborg Bear',
        page: 'scam-education',
        messages: [
            `Welcome to the education centre. You can get information to help you protect yourself against scams here.`,
            `This is where we gather useful information to update you knowledge on scams.`,
            `The scam education centre will have many activities and information to help protect you from scammers.`,
        ]
    },
    {
        guardianName: 'Cyborg Bear',
        page: 'anti-scam-defenders',
        messages: [
            `You can find automatic anti-scam options to protect you from known scammers here.`,
            `Take advantage of all of our automated defences. Remember to active all defences you need.`,
            `Activate your anti-scam defences here. This will reduce contact from scammers.`,
        ]
    },
    {
        guardianName: 'Cyborg Bear',
        page: 'contribution-community',
        messages: [
            `Engage with the anti-scam community and contribute to anti-scam efforts here.`,
            `Utilize the links here to access forums and communities to advance your knowledge on scams.`,
        ]
    },
    {
        guardianName: 'Cyborg Bear',
        page: 'archives',
        messages: [
            `This is the archives. We store your saved interactions here.`,
            `You can access your saved interactions in the archive vault.`,
            `The archives vault is where your saved interaction files are stored.`,
        ]
    },
    /////////////////////////
    {
        guardianName: 'Zombie Myles',
        page: 'StartIdentifyScam',
        messages: [
            "Welcome to the Scam identification centre. This is where you identify possible scam scenarios.",
            `Over here, we use logic and the power of AI to help you identify possible scams`,
            `Scam protect's elemental fingerprinting for scam identification is powered by "The Wisdom Approach"`,
        ]
    },
    {
        guardianName: 'Zombie Myles',
        page: 'scam-education',
        messages: [
            `Welcome to the education centre. You can get information to help you protect yourself against scams here.`,
            `This is where we gather useful information to update you knowledge on scams.`,
            `The scam education centre will have many activities and information to help protect you from scammers.`,
        ]
    },
    {
        guardianName: 'Zombie Myles',
        page: 'anti-scam-defenders',
        messages: [
            `You can find automatic anti-scam options to protect you from known scammers here.`,
            `Take advantage of all of our automated defences. Remember to active all defences you need.`,
            `Activate your anti-scam defences here. This will reduce contact from scammers.`,
        ]
    },
    {
        guardianName: 'Zombie Myles',
        page: 'contribution-community',
        messages: [
            `Engage with the anti-scam community and contribute to anti-scam efforts here.`,
            `Help us to fight scammers here. Join and contribute to the community.`,
        ]
    },
    {
        guardianName: 'Zombie Myles',
        page: 'archives',
        messages: [
            `This is the archives. We store your saved interactions here.`,
            `You can access your saved interactions in the archive vault.`,
            `The archives vault is where your saved interaction files are stored.`,
        ]
    },
    /////////////////////////
    {
        guardianName: 'Super Puppy',
        page: 'StartIdentifyScam',
        messages: [
            "Welcome to the Scam identification centre. This is where you identify possible scam scenarios.",
            `You can use "elemental fingerprinting" to identify possible scams here.`,
            `Scam protect's elemental fingerprinting for scam identification is powered by "The Wisdom Approach"`,
        ]
    },
    {
        guardianName: 'Super Puppy',
        page: 'scam-education',
        messages: [
            `Welcome to the education centre. You can get information to help you protect yourself against scams here.`,
            `This is where we gather useful information to update you knowledge on scams.`,
            `The scam education centre will have many activities and information to help protect you from scammers.`,
        ]
    },
    {
        guardianName: 'Super Puppy',
        page: 'anti-scam-defenders',
        messages: [
            `You can find automatic anti-scam options to protect you from known scammers here.`,
            `We observe and gather data of known scammers to help protect you.`,
            `Activate your anti-scam defences here. This will reduce contact from scammers.`,
        ]
    },
    {
        guardianName: 'Super Puppy',
        page: 'contribution-community',
        messages: [
            `Engage with the anti-scam community and contribute to anti-scam efforts here.`,
            `Utilize the links here to access forums and communities to advance your knowledge on scams.`,
        ]
    },
    {
        guardianName: 'Super Puppy',
        page: 'archives',
        messages: [
            `This is the archives. We store your saved interactions here.`,
            `You can access your saved interactions in the archive vault.`,
            `The archives vault is where your saved interaction files are stored.`,
        ]
    },
    ///////////
    /////////////////////////
    {
        guardianName: 'The Twins - Kungfu Bears',
        page: 'StartIdentifyScam',
        messages: [
            "Welcome to the Scam identification centre. This is where you identify possible scam scenarios.",
            `You can use "elemental fingerprinting" to identify possible scams here.`,
            `Over here, we use logic and the power of AI to help you identify possible scams`,
        ]
    },
    {
        guardianName: 'The Twins - Kungfu Bears',
        page: 'scam-education',
        messages: [
            `Welcome to the education centre. You can get information to help you protect yourself against scams here.`,
            `This is where we gather useful information to update you knowledge on scams.`,
            `The scam education centre will have many activities and information to help protect you from scammers.`,
        ]
    },
    {
        guardianName: 'The Twins - Kungfu Bears',
        page: 'anti-scam-defenders',
        messages: [
            `You can find automatic anti-scam options to protect you from known scammers here.`,
            `Take advantage of all of our automated defences. Remember to active all defences you need.`,
            `Activate your anti-scam defences here. This will reduce contact from scammers.`,
        ]
    },
    {
        guardianName: 'The Twins - Kungfu Bears',
        page: 'contribution-community',
        messages: [
            `Engage with the anti-scam community and contribute to anti-scam efforts here.`,
            `Utilize the links here to access forums and communities to advance your knowledge on scams.`,
            `Help us to fight scammers here. Join and contribute to the community.`,
        ]
    },
    {
        guardianName: 'The Twins - Kungfu Bears',
        page: 'archives',
        messages: [
            `This is the archives. We store your saved interactions here.`,
            `You can access your saved interactions in the archive vault.`,
            `The archives vault is where your saved interaction files are stored.`,
        ]
    },
    /////////////////////////
    {
        guardianName: 'P & P Observation Unit: Poodie and Panda',
        page: 'StartIdentifyScam',
        messages: [
            "Welcome to the Scam identification centre. This is where you identify possible scam scenarios.",
            `You can use "elemental fingerprinting" to identify possible scams here.`,
            `Over here, we use logic and the power of AI to help you identify possible scams`,
            `Scam protect's elemental fingerprinting for scam identification is powered by "The Wisdom Approach"`,
        ]
    },
    {
        guardianName: 'P & P Observation Unit: Poodie and Panda',
        page: 'scam-education',
        messages: [
            `Welcome to the education centre. You can get information to help you protect yourself against scams here.`,
            `This is where we gather useful information to update you knowledge on scams.`,
            `The scam education centre will have many activities and information to help protect you from scammers.`,
        ]
    },
    {
        guardianName: 'P & P Observation Unit: Poodie and Panda',
        page: 'anti-scam-defenders',
        messages: [
            `You can find automatic anti-scam options to protect you from known scammers here.`,
            `We observe and gather data of known scammers to help protect you.`,
            `Activate your anti-scam defences here. This will reduce contact from scammers.`,
        ]
    },
    {
        guardianName: 'P & P Observation Unit: Poodie and Panda',
        page: 'contribution-community',
        messages: [
            `Engage with the anti-scam community and contribute to anti-scam efforts here.`,
            `Utilize the links here to access forums and communities to advance your knowledge on scams.`,
        ]
    },
    {
        guardianName: 'P & P Observation Unit: Poodie and Panda',
        page: 'archives',
        messages: [
            `This is the archives. We store your saved interactions here.`,
            `You can access your saved interactions in the archive vault.`,
            `The archives vault is where your saved interaction files are stored.`,
        ]
    }
];
export default guardianMessages;

export const getRandomGuardianMessage = (guardianName: string, page: string) => {
    const record = guardianMessages.find(
        x =>
            x.guardianName === guardianName &&
            x.page === page
    );

    if (!record || !record.messages || record.messages.length === 0) {
        return "No message available for this guardian/page.";
    }

    const randomIndex = Math.floor(Math.random() * record.messages.length);
    return record.messages[randomIndex];
};